import { DELIVERY_DATE_MEANING, type DeliveryDateMeaning } from "~/app/store/bffApi";

export const isShipmentDateMeaning = (meaning?: DeliveryDateMeaning) => meaning === DELIVERY_DATE_MEANING.SHIPMENT;
